module.exports = __webpack_public_path__ + "img/warning.234dc1e5.png";